export const spanWrap = (string, classname = '', increment = 200, delay = 0) => {
    string = string.split(' ');
    let output = [];
    for (let w of string) {
        output.push(`<span style="animation-delay: ${delay}ms;" class="${classname}">${w}</span>`);
        delay += increment;
    }
    return output.join(' ').replace(/class=""/g, '');
}